import React from 'react';
import {
  Dropdown as AntdDropdown,
  type DropdownProps as AntdDropdownProps,
} from 'antd';

export interface DropdownProps extends Omit<
  AntdDropdownProps,
  'popupRender' | 'onOpenChange' | 'open' | 'overlay'
> {
  overlay?: React.ReactNode | (() => React.ReactNode);
  popupRender?: AntdDropdownProps['popupRender'];
  visible?: boolean;
  open?: boolean;
  onVisibleChange?: (open: boolean) => void;
  onOpenChange?: AntdDropdownProps['onOpenChange'];
}

export const Dropdown: React.FC<DropdownProps> = ({
  overlay,
  popupRender,
  visible,
  open,
  onVisibleChange,
  onOpenChange,
  ...rest
}) => {
  const resolvedPopupRender =
    popupRender ??
    (overlay !== undefined
      ? () => (typeof overlay === 'function' ? overlay() : overlay)
      : undefined);

  const resolvedOpen = open ?? visible;
  const resolvedOnOpenChange =
    onOpenChange ??
    (onVisibleChange
      ? (nextOpen: boolean) => onVisibleChange(nextOpen)
      : undefined);

  return (
    <AntdDropdown
      {...rest}
      open={resolvedOpen}
      onOpenChange={resolvedOnOpenChange}
      popupRender={resolvedPopupRender}
    />
  );
};
